module.exports = __webpack_public_path__ + "static/img/title_image@2x.4dca5dab.png";